import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Popover } from 'antd';
import * as TherapistActions from '../../actions/therapist';
import ViewDetailsWrapper from './styles/view-details-popover.style';
import Loader from '../Loader/loader';
import moment from 'moment';


class ViewDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false
		};
		this.getVisitDetails = this.getVisitDetails.bind(this);
		this.closeVisitDetails = this.closeVisitDetails.bind(this);
	}

	closeVisitDetails(){
		this.setState({
			visible: false
		})
	}

	getVisitDetails(){
		const { callDetails, dispatch } = this.props;
		this.setState({
			visible: true
		})
		dispatch(TherapistActions.unsetActiveCallDetails());
		dispatch(TherapistActions.getActiveCallDetails({callId: callDetails.callId}));

	}
	render() {
		const { therapists, onCallStatus, removeCall } = this.props;
		const { activeCall } = therapists;
		let content;
		if(activeCall.callId){
		content = (
			<ViewDetailsWrapper>
			<div className="viewdetails-content">
				<span className="close-sidebar" onClick={this.closeVisitDetails}>&times;</span>
			  <div className="content">
			  <h3>{activeCall.patient}</h3>
			  <h4>DOB: {activeCall.dob ? moment(activeCall.dob).format("MM/DD/YYYY") : ""}</h4>
			  {activeCall.relInfo.name && [<h1>caregiver</h1>,
			  <h3>{activeCall.relInfo.name}</h3>,
			  <h2 className="p-0">+{activeCall.relInfo.phone}</h2>,
			  <h4>{activeCall.relInfo.relation}</h4>]}
			  {activeCall.scheduleInfo._id ? [<h1>visit type</h1>,
			  <h2>{activeCall.scheduleInfo.Visit.Reason}</h2>,
			  <h1>confirmation status</h1>,
			  <h2>{activeCall.scheduleInfo.scheduleStatus}</h2>] :
			  <h5>NO VISIT ON YOUR SCHEDULE FOR TODAY</h5>}
			  </div>
			  {/* <div className="actionWrapper">
			  <div className="control disconnect">
			  <img src="/images/microphone@2x.png" width="10" />
			  </div>
			  <div className="control connect">
			  <img src="/images/video-off@2x.png" width="10" />
			  </div>
			  </div> */}
			  {activeCall.patientDeviceInfo.OS && 
			  <div className="classifications">
			  <div className="item">
				  <span>Device</span>
				  <h1>{activeCall.patientDeviceInfo.device}</h1>
			  </div>
			  <div className="item">
			  <span>OS</span>
				  <h1>{activeCall.patientDeviceInfo.OS}</h1>
			  </div>
			  <div className="item">
			  <span>Browser</span>
				  <h1>{activeCall.patientDeviceInfo.browser}</h1>
			  </div>
			  </div>}
			  {!onCallStatus && <button className="removeParticipant-btn" onClick={removeCall}>remove</button>}
			</div>
			</ViewDetailsWrapper>
		  );
		}
		else{
			content = <div className="viewdetails-content"><Loader /></div>
		}
		// onMouseOut={this.closeVisitDetails}
		return (
			<ViewDetailsWrapper>
			<Popover overlayClassName="view-details" placement="rightTop" content={content} trigger="click" 
        		visible={this.state.visible}>
			<button className="visit-details kurebtn"  onClick={() => this.getVisitDetails()}>visit details</button>
			</Popover>
			</ViewDetailsWrapper>
		  ) 
	}
}

export default connect(
	state => state
)(ViewDetails);

